export default __webpack_public_path__ + "static/media/CNo.83-8.1b0dc46c.jpg";